<template>
    <div class="NovaOrientacao" >
        <b-modal ref="modal-cadastro" id="modalCadastro" size="xl" :hide-footer="true" :hide-header="true">
            <div class="w-100 text-end txt-size-20 txt-cores-6">
                <span @click="close"><i class="fas fa-times c-pointer"></i></span>
            </div>
            <form class="px-3 pb-3" id="formNovaOrientacao">

                <div class="row">
                    <span class="txt-p txt-roxo-1 txt-size-20 txt-w-bold mb-2">
                        Criando nova pergunta
                    </span>
                    <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                        Preencha todos os campos com a maior precisão de informação possível, Para que sua necessidade seja entendida pelo nosso corpo técnico e o resultado seja de acordo com a sua necessidade.
                    </p>
                </div>
                <div class="row mb-4">
                    <span class="txt-p txt-cores-1 txt-w-5 txt-size-20">
                        1. Selecione a modalidade da orientação que gostaria de receber:
                    </span>
                    <div class="d-flex row justify-content-evenly">
                        <div :class="'box-tp-orientacao txt-p txt-cores-1 txt-size-20 txt-w-bold me-2 mt-2 text-center '+(novaOrientacao.idTipoPergunta == item.idTipoPergunta?'selected':'')" v-for="item in lstTipoPergunta" :key="item.idTipoPergunta" @click="selecionaTipoPergunta(item.idTipoPergunta)">
                            <i :class="item.icone"></i>
                            <span class="txt-size-14">
                                {{item.nmTipoPergunta}}
                            </span>
                            <p class="txt-size-14 txt-w-4 mb-0">
                                <template v-if="item.hrPrazo > 0">
                                    {{item.hrPrazo}} horas úteis
                                </template>
                                <template v-else>
                                    Imediato
                                </template>
                            </p>

                        </div>
                    </div>
                    
                    <div class="mensagem-tipo " v-if="novaOrientacao">
                        
                        <div class="mensagem-aviso mensagem-estudo mt-4" v-if="showMsgEstudo">
                            * Poderão ser formulados no máximo 04 (quatro) questionamentos/perguntas/pedidos de esclarecimentos, a cada Estudo técnico solicitado. Perguntas excedentes serão considerados um novo e independente Estudo Técnico.
                        </div>
                        <div class="mensagem-aviso mensagem-resposta mt-4" v-if="showMsgResposta">
                            * Poderão ser formulados no máximo 02 (dois) questionamentos/perguntas/pedidos de esclarecimentos, a cada Resposta Objetiva solicitada. Perguntas excedentes serão consideradas uma nova e independente Resposta Objetiva.
                        </div>
                        <div class="mensagem-aviso mensagem-mentoria mt-4" v-if="showMsgMentoria">
                            * A Mentoria online consiste na prestação de serviços de capacitação interativa em matéria de Licitações e Contratos, a ser realizada por meio da plataforma zoom.<br />
                            *** Por ocasião da formulação da demanda, deverão ser pontualmente delimitadas as temáticas a serem abrangidas pela mentoria.
                        </div>
                        <div class="mensagem-aviso mensagem-whats mt-4" v-if="showMsgWhats">
                            * A orientação Via WhatsApp/ Áudio  será procedida por meio de áudio, a ser disponibilizado à Contratante via sistema para registro.
                        </div>
                        <div class="mensagem-aviso mensagem-telefonico mt-4" v-if="showMsgTelefonico">
                            * O contato telefônico destina-se à resolução de questões pontuais e urgentes.
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <span class="txt-p txt-cores-1 txt-w-5 txt-size-20">
                        2. Telefone para contato:
                    </span>
                    <div class="form-group">
                        <vue-mask class="form-control"
                                  v-model="novaOrientacao.nrTelefoneContato"
                                  mask="(00) 00000-0000"
                                  :raw="false"
                                  :options="options" required>
                        </vue-mask>
                    </div>
                </div>
                <div class="row mb-4">
                    <span class="txt-p txt-cores-1 txt-w-5 txt-size-20">
                        3. Sua pergunta é sobre qual tema ou assunto?
                    </span>
                    <div class="form-group">
                        <input type="text" class="form-control" id="dsAssunto" placeholder="Digite o tema ou assunto da pergunta" v-model="novaOrientacao.dsAssunto" maxlength="100" required>
                    </div>
                </div>
                <div class="row mb-4">
                    <span class="txt-p txt-cores-1 txt-w-5 txt-size-20">
                        4. Descrição da sua pergunta:
                    </span>
                    <div class="form-group">
                        <textarea class="form-control" id="dsPergunta" rows="5" placeholder="Descreva sua pergunta" v-model="novaOrientacao.dsPergunta" :maxlength="limiteCaracteres" required></textarea>
                    </div>
                    <div class="w-100 text-rigth">
                        <span class="txt-p txt-erro txt-size-14" v-if="novaOrientacao.dsPergunta != null && showQuantidadeCaracteres && limiteCaracteres != ''">
                            {{novaOrientacao.dsPergunta.length}} de {{limiteCaracteres}} caracteres
                        </span>
                    </div>

                </div>
                <div class="row">
                    <div class="form-group w-100">
                        <button class="btn btn-roxo w-100" type="button" :disabled="!validaOrientacao" @click="enviar" v-if="!flCortesia">Enviar pergunta</button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro, getIconeTipoPergunta } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'NovaOrientacao',
        components: {
            vueMask,
        },
        data: function () {
            return {
                lstTipoPergunta: [],

                limiteCaracteres: 500,
                showQuantidadeCaracteres: false,

                novaOrientacao: {
                    idTipoPergunta: null,
                    nrTelefoneContato: '',
                    dsAssunto: null,
                    dsPergunta: null,
                },

                options: {
                    placeholder: 'Digite o número com o DDD',
                },

                showMsgEstudo: false,
                showMsgResposta: false,
                showMsgMentoria: false,
                showMsgWhats: false,
                showMsgTelefonico: false,
            }
        },
        props: {
            showModal: Boolean,
            recarregaHome: Function,
            flCortesia: Boolean,
        },
        computed: {
            validaOrientacao() {
                if (this.novaOrientacao.idTipoPergunta == 0 || this.novaOrientacao.idTipoPergunta == null) {
                    return false;
                }

                if (this.novaOrientacao.nrTelefoneContato == '' || this.novaOrientacao.nrTelefoneContato == null) {
                    return false;
                }

                if (this.novaOrientacao.dsAssunto == '' || this.novaOrientacao.dsAssunto == null) {
                    return false;
                }

                if (this.novaOrientacao.dsPergunta == '' || this.novaOrientacao.dsPergunta == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Pergunta/`, $this.novaOrientacao)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Sua solicitação de Orientação foi registrada com sucesso!");
                                $this.recarregaHome();
                                $this.$refs['modal-cadastro'].hide();
                            } else {
                                avisoErro("Não foi possível realizar seu cadastro.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formNovaOrientacao')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.novaOrientacao.dsPergunta.length > this.limiteCaracteres) {
                        avisoErro("O limite de caracteres foi ultrapassado")
                        this.showQuantidadeCaracteres = true;

                        return false;
                    }
                }
                

                return true;
            },

            load() {
                this.carregarTiposPerguntas();
            },

            selecionaTipoPergunta(idTipoPergunta) {
                this.novaOrientacao.idTipoPergunta = idTipoPergunta;
                this.limiteCaracteres = (this.lstTipoPergunta.find(x => x.idTipoPergunta == idTipoPergunta).qtdCaracteresPergunta == 0 ? "" : this.lstTipoPergunta.find(x => x.idTipoPergunta == idTipoPergunta).qtdCaracteresPergunta);

                var tipoPergunta = this.lstTipoPergunta.find(x => x.idTipoPergunta == idTipoPergunta);

                if (tipoPergunta.nmTipoPergunta.includes('Estudo Técnico')) {
                    this.showMsgEstudo = true;
                } else {
                    this.showMsgEstudo = false;
                }

                if (tipoPergunta.nmTipoPergunta.includes('Resposta Objetiva')) {
                    this.showMsgResposta = true;
                } else {
                    this.showMsgResposta = false;
                }

                if (tipoPergunta.nmTipoPergunta.includes('Mentoria Online')) {
                    this.showMsgMentoria = true;
                } else {
                    this.showMsgMentoria = false;
                }

                if (tipoPergunta.nmTipoPergunta.includes('Atendimento Telefônico')) {
                    this.showMsgTelefonico = true;
                } else {
                    this.showMsgTelefonico = false;
                }

                if (tipoPergunta.nmTipoPergunta.includes('Atendimento via WhatsApp')) {
                    this.showMsgWhats = true;
                } else {
                    this.showMsgWhats = false;
                }
                
            },

            carregarTiposPerguntas() {
                let $this = this;
                axios.get(`${urlApi}/TipoPergunta/Get?flAtivo=true`)
                    .then(res => {                        
                        if (res.data.success) {
                            $this.lstTipoPergunta = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.icone = getIconeTipoPergunta(item.nmTipoPergunta);
                                $this.lstTipoPergunta.push(item);
                            }
                        } else {
                            avisoErro("Não foi possível carregar suas orientações.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            close() {
                this.$refs['modal-cadastro'].hide();
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-cadastro'].show();
                this.novaOrientacao = {
                    idTipoPergunta: null,
                    nrTelefoneContato: '',
                    dsAssunto: null,
                    dsPergunta: null,
                };
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* MODAL */
    .box-tp-orientacao {
        background: #FFFFFF;
        border: 1px solid #732A90;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 0;
        width: 17%;
        min-width: 110px;
        cursor: pointer;
    }

        .box-tp-orientacao.selected {
            font-weight: bold;
            border: 2px solid #732A90;
        }

    .form-control {
        border: 1px solid #474747;
    }

    .mensagem-aviso {
        font-size: 16px;
        color: #5B5B5B !important;
        font-weight: bold;
    }
</style>

